import { FC } from "react";
import Image from "next/image";
import { useTranslation } from "next-i18next";

import SpecComponent from "./spec-component";

import { ProductWithSpecificationsAndDetails } from "@interfaces/product";
import { getMediaSizes, imageLoader } from "@utils/get-media";

type Props = Pick<
  ProductWithSpecificationsAndDetails,
  "specificationPhoto" | "specifications"
>;

const TechnicalSpecifications: FC<Props> = ({
  specifications,
  specificationPhoto,
}) => {
  const { t } = useTranslation("product", { keyPrefix: "specs" });

  return specifications && specifications.length > 0 ? (
    <div className="flex flex-col w-full justify-center my-20 pb-10 text-black">
      <h2 className="my-4 text-2xl font-semibold border-b border-gray-800 pb-3 mx-5">
        {t("title")}
      </h2>
      <div className="flex flex-wrap px-2">
        <div className="w-full md:w-1/2 px-3">
          {specifications.map((spec) => (
            <SpecComponent {...spec} key={spec.name} />
          ))}
        </div>
        <div className="w-full md:w-1/2 px-3">
          <div className="w-full xl:w-1/2">
            <div className="aspect-w-1 aspect-h-1">
              {specificationPhoto && (
                <Image
                  src={specificationPhoto}
                  loader={imageLoader}
                  alt={t("title")}
                  layout="fill"
                  objectFit="cover"
                  sizes={getMediaSizes([
                    { breakpoint: "sm", size: "90vw" },
                    { breakpoint: "xl", size: "50vw" },
                    { size: "25vw" },
                  ])}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default TechnicalSpecifications;
